import { callAPI } from 'Shared/helpers'

export const ActionTypes = {
  FETCH_INITIAL_DATA_REQUEST: 'FETCH_INITIAL_DATA_REQUEST',
  FETCH_INITIAL_DATA_RECEIVED: 'FETCH_INITIAL_DATA_RECEIVED',
}

export const fetchInitialData = () => (dispatch, getState) => {
  dispatch({
    type: ActionTypes.FETCH_INITIAL_DATA_REQUEST,
  })

  const state = getState()
  const dataURL = state.misc.fetchInitialDataURL
  callAPI(dataURL, 'GET')
  .then(response => {
    dispatch({
      type: ActionTypes.FETCH_INITIAL_DATA_RECEIVED,
      data: response,
    })
  })
  .catch(() => {
    console.error('Error while fetching vacations data!')
  })
}
